<template>
  <geneltanitim :tanitimTip="tanitimTip"></geneltanitim>
</template>

<script>
import geneltanitim from "@/components/app/customcomp/geneltanitim"

export default {
    name:'otelfiyatkodu',
    data(){
        return{
            tanitimTip:8,
        }
    },
    components:{
        geneltanitim
    }

}
</script>

<style>

</style>